import { useMemo } from 'react';
import {
  AccessPermitPoolingGroupCombinedInfo,
  LicensePlate,
  Maybe,
  UnifiedPermit,
  UsageType,
} from 'types/generatedSchemaTypes';
import { showLicensePlate } from 'utils/permitUtils';

type UsePoolingGroupsData = {
  availableSpots: number | undefined;
  poolingGroups: AccessPermitPoolingGroupCombinedInfo[] | undefined;
  showLicensePlate: boolean;
  usageType: Maybe<UsageType> | undefined;
  isWaitingActivation: boolean | undefined;
  licensePlatesInPermit: LicensePlate[] | undefined;
};

export const useMultiPoolPermitData = (
  permitId: string,
  permits: Maybe<UnifiedPermit[]> | undefined
): UsePoolingGroupsData => {
  return useMemo(() => {
    const permit = permits?.find((permit) => permit.id === permitId);

    return {
      poolingGroups: permit?.accessPermitPoolingGroupInfo?.filter(
        (group): group is AccessPermitPoolingGroupCombinedInfo => group !== null
      ),
      availableSpots: permit?.accessPermitPoolingGroupInfo?.reduce(
        (sum, group) =>
          sum + (!group?.capacityHidden ? (group?.freePoolingSpots ?? 0) : 0),
        0
      ),
      showLicensePlate: showLicensePlate(permit),
      usageType: permit?.usageType,
      isWaitingActivation: permit?.isWaitingActivation,
      licensePlatesInPermit: permit?.registrationPlates
        ?.filter((plate): plate is LicensePlate => plate !== null)
        .map(({ plateText, countryCode }) => ({ plateText, countryCode })),
    };
  }, [permits, permitId]);
};

export default useMultiPoolPermitData;
